<template>
  <div class="w-full no-gutter items-center justify-center">
      <vx-card ref="filterCard" class="mb-2" >
            <h5 class="text-center text-danger"> {{getInfoUltimaAtualizacao}}</h5>
            <p class="text-center text-primary"> Os avisos gerados pelos seus veículos são enviados por email e pelo aplicativo. Verifique abaixo se os dados estão corretos para continuar recebendo os avisos. </p>
            <p class="text-center text-primary"> Caso deseje atualizar algum dos dados, informe nos campos abaixo e clique em "Atualizar Dados". </p>
            <p class="text-center text-primary"> Para não exibir mais essa tela clique em "Os dados já estão atualizados".</p>
            <div class="vx-row mt-2">
                <div class="vx-col sm:w-1/4 w-full mb-2" >
                        <vx-input-group>
                            <label class="vs-input--label" >{{$t('TelaAlterarVeiculo_lResponsavel1')}}</label>                                                               
                            <vs-input v-model="poUpConfirmacaoDados.nomeContatoResponsavel1" type="email" />   
                            <template slot="append">
                                <div class="append-text btn-addon mt-6">                                
                                    <vs-button color="primary" type="border" icon-pack="feather" icon="icon-refresh-cw" @click="atualizarResponsavel1" :disabled="!poUpConfirmacaoDados.nomeContatoResponsavel1"></vs-button>                  
                                </div>
                            </template>
                        </vx-input-group>                     
                </div> 
                <div class="vx-col sm:w-1/4 w-full mb-2" >
                        <vx-input-group>
                            <label class="vs-input--label" >{{$t('TelaAlterarVeiculo_lResponsavel2')}}</label>                                                               
                        <vs-input v-model="poUpConfirmacaoDados.nomeContatoResponsavel2" type="email"/>                        
                            <template slot="append">
                                <div class="append-text btn-addon mt-6">                                
                                    <vs-button color="primary" type="border" icon-pack="feather" icon="icon-refresh-cw" @click="atualizarResponsavel2" :disabled="!poUpConfirmacaoDados.nomeContatoResponsavel2"></vs-button>                  
                                </div>
                            </template>
                        </vx-input-group>                     
                </div> 
            </div>
            <div class="vx-row mt-2">
                <div class="vx-col sm:w-1/4 w-full mb-2" >
                        <vx-input-group>
                            <label class="vs-input--label" >{{$t('TelaAlterarVeiculo_lEmail1')}}</label>                                                               
                            <vs-input v-model="poUpConfirmacaoDados.emailAvisoExcessoVelocidade" type="email" />   
                            <template slot="append">
                                <div class="append-text btn-addon mt-6">                                
                                    <vs-button color="primary" type="border" icon-pack="feather" icon="icon-refresh-cw" @click="atualizarEmail1" :disabled="!poUpConfirmacaoDados.emailAvisoExcessoVelocidade"></vs-button>                  
                                </div>
                            </template>
                        </vx-input-group>                     
                </div> 
                <div class="vx-col sm:w-1/4 w-full mb-2" >
                        <vx-input-group>
                            <label class="vs-input--label" >{{$t('TelaAlterarVeiculo_lEmail2')}}</label>                                                               
                        <vs-input v-model="poUpConfirmacaoDados.emailAvisoSaidaCerca" type="email"/>                        
                            <template slot="append">
                                <div class="append-text btn-addon mt-6">                                
                                    <vs-button color="primary" type="border" icon-pack="feather" icon="icon-refresh-cw" @click="atualizarEmail2" :disabled="!poUpConfirmacaoDados.emailAvisoSaidaCerca"></vs-button>                  
                                </div>
                            </template>
                        </vx-input-group>                     
                </div> 
                <div class="vx-col sm:w-1/4 w-full mb-2" >
                        <vx-input-group>
                            <label class="vs-input--label" >{{$t('TelaAlterarVeiculo_lCelular1')}}</label>                                                               
                            <vs-input v-model="poUpConfirmacaoDados.celularlAvisoExcessoVelocidade" type="number" />                        
                            <template slot="append">
                                <div class="append-text btn-addon mt-6">                                
                                    <vs-button color="primary" type="border" icon-pack="feather" icon="icon-refresh-cw" @click="atualizarCelular1" :disabled="!poUpConfirmacaoDados.celularlAvisoExcessoVelocidade"></vs-button>                  
                                </div>
                            </template>
                        </vx-input-group>                     
                </div> 
                <div class="vx-col sm:w-1/4 w-full mb-2" >
                        <vx-input-group>
                            <label class="vs-input--label" >{{$t('TelaAlterarVeiculo_lCelular2')}}</label>                                                               
                            <vs-input v-model="poUpConfirmacaoDados.celularlAvisoSaidaCerca" />                        
                            <template slot="append">
                                <div class="append-text btn-addon mt-6">                                
                                    <vs-button color="primary" type="border" icon-pack="feather" icon="icon-refresh-cw" @click="atualizarCelular2" :disbabled="!poUpConfirmacaoDados.celularlAvisoSaidaCerca"></vs-button>                  
                                </div>
                            </template>
                        </vx-input-group>                     
                </div>                 
            </div>     
            <div class="vx-row mt-2">
                <div class="vx-col w-full mb-2 text-center" >
                    <vs-button @click="salvarDadosVeiculos" color="primary">Atualizar Dados</vs-button>                             
                    <vs-button @click="descartarSalvarDadosVeiculos" type="border" class="ml-2" color="dark">Os dados já estão atualizados</vs-button>                             
                </div>
            </div>
            <vs-alert color="danger" title="Atenção" :active.sync="poUpConfirmacaoDados.exibirMensagemErro" closable icon-pack="feather" close-icon="icon-x">
                {{poUpConfirmacaoDados.mensagem}}
            </vs-alert>
            <vs-alert color="success" title="Atenção" :active.sync="poUpConfirmacaoDados.exibirMensagemSucesso" closable icon-pack="feather" close-icon="icon-x">
                {{poUpConfirmacaoDados.mensagem}}
            </vs-alert>
      </vx-card>
      <vx-card>
          <div class="vx-row" >
                <div class="vx-col w-full mb-2">     
                    <vs-table hoverFlat stripe :data="listaVeiculos" v-if="listaVeiculos" noDataText="...">
                        <template slot="thead">
                            <vs-th>Veículo</vs-th>
                            <vs-th>Placa</vs-th>
                            <vs-th>Responsável 1</vs-th>
                            <vs-th>Email 1</vs-th>
                            <vs-th>Telefone 1</vs-th>
                            <vs-th>Responsável 2</vs-th>
                            <vs-th>Email 2</vs-th>                            
                            <vs-th>Telefone 2</vs-th>
                        </template>

                        <template slot-scope="{data}"> 
                            <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
                                <vs-td :data="data[indextr].modelo">
                                    <small>{{data[indextr].modelo}}</small>                               
                                </vs-td>

                                <vs-td :data="data[indextr].placa">
                                    <small>{{data[indextr].placa}}</small>
                                </vs-td>

                                <vs-td :data="data[indextr].nomeContatoResponsavel1">
                                    
                                    <template>                                      
                                        <vs-textarea v-model="tr.nomeContatoResponsavel1" height="60px"  maxlength="255"/>                        
                                    </template>
                                </vs-td>
                                <vs-td :data="data[indextr].emailAvisoExcessoVelocidade">                                    
                                    <template>                                      
                                        <vs-input v-model="tr.emailAvisoExcessoVelocidade" class="w-full"/>                        
                                    </template>
                                </vs-td>
                                <vs-td :data="data[indextr].celularlAvisoExcessoVelocidade">                                    
                                    <template>                                      
                                        <vs-input v-model="tr.celularlAvisoExcessoVelocidade" class="w-full"/>                        
                                    </template>
                                </vs-td>                               
                                <vs-td :data="data[indextr].nomeContatoResponsavel2">                                    
                                    <template>                                      
                                        <vs-textarea v-model="tr.nomeContatoResponsavel2" height="60px"  maxlength="255"/>                        
                                    </template>
                                </vs-td>
                                <vs-td :data="data[indextr].emailAvisoSaidaCerca">                                    
                                    <template>                                      
                                        <vs-input v-model="tr.emailAvisoSaidaCerca" class="w-full"/>                        
                                    </template>
                                </vs-td>                               
                                <vs-td :data="data[indextr].celularlAvisoSaidaCerca">                                    
                                    <template>                                      
                                        <vs-input v-model="tr.celularlAvisoSaidaCerca" class="w-full"/>                        
                                    </template>
                                </vs-td>
                                
                            </vs-tr>
                        </template>
                    </vs-table>                          
                </div>   
            </div> 
      </vx-card>
  </div>
</template>
<script>
import axios from "@/axios.js"
import 'vue-select/dist/vue-select.css';

export default {
    data() {
        return {          
            poUpConfirmacaoDados: {
              popupActive: false,    
              exibirMensagemErro: false,  
              exibirMensagemSucesso: false,  
              mensagem: '',
              emailAvisoExcessoVelocidade: null,
              emailAvisoSaidaCerca: null, 
              celularlAvisoExcessoVelocidade: null, 
              celularlAvisoSaidaCerca: null,
              nomeContatoResponsavel1: null,
              nomeContatoResponsavel2: null
            },
            listaVeiculos: [],  
        }
    },
    mounted() {  
        this.$vs.loading();              
        this.fetchDadosVeiculoParaConfirmacao();
    },
    computed: {
        getInfoUltimaAtualizacao() {
            if (this.$store.state.AppActiveUser.hasOwnProperty('dataHoraUltimaConfirmacaoDadosGrupo') ) {
                return "Última confirmação em " + this.$store.state.AppActiveUser.dataHoraUltimaConfirmacaoDadosGrupo + ".";
            } else if (this.$store.state.AppActiveUser.hasOwnProperty('dataHoraUltimaConfirmacaoDados') ) {
                return "Última confirmação em " + this.$store.state.AppActiveUser.dataHoraUltimaConfirmacaoDados + ".";
            } else {
                return "Já faz um tempo que você não atualiza os dados.";
            }
        }
    },
    methods: {
        atualizarResponsavel1() {
            let novoValor = this.poUpConfirmacaoDados.nomeContatoResponsavel1;            
             if (this.listaVeiculos) {
                for (var i=0; i < this.listaVeiculos.length; i++) {
                    this.listaVeiculos[i].nomeContatoResponsavel1 = novoValor;                     
                }
            }   
        },
        atualizarResponsavel2() {
            let novoValor = this.poUpConfirmacaoDados.nomeContatoResponsavel2;            
             if (this.listaVeiculos) {
                for (var i=0; i < this.listaVeiculos.length; i++) {
                    this.listaVeiculos[i].nomeContatoResponsavel2 = novoValor;                     
                }
            }   
        },
        atualizarEmail1() {
            let novoValor = this.poUpConfirmacaoDados.emailAvisoExcessoVelocidade;            
             if (this.listaVeiculos) {
                for (var i=0; i < this.listaVeiculos.length; i++) {
                    this.listaVeiculos[i].emailAvisoExcessoVelocidade = novoValor;                     
                }
            }   
        },
        atualizarEmail2() {
             let novoValor = this.poUpConfirmacaoDados.emailAvisoSaidaCerca;             
             if (this.listaVeiculos) {
                for (var i=0; i < this.listaVeiculos.length; i++) {
                    this.listaVeiculos[i].emailAvisoSaidaCerca = novoValor;                     
                }
            }   
        },
        atualizarCelular1() {
            let novoValor = this.poUpConfirmacaoDados.celularlAvisoExcessoVelocidade;            
             if (this.listaVeiculos) {
                for (var i=0; i < this.listaVeiculos.length; i++) {
                    this.listaVeiculos[i].celularlAvisoExcessoVelocidade = novoValor;                     
                }
            }   
        },
        atualizarCelular2() {
            let novoValor = this.poUpConfirmacaoDados.celularlAvisoSaidaCerca;            
             if (this.listaVeiculos) {
                for (var i=0; i < this.listaVeiculos.length; i++) {
                    this.listaVeiculos[i].celularlAvisoSaidaCerca = novoValor;                     
                }
            }   
        },
        abrirPopUpOcorrencias() {
            this.poUpConfirmacaoDados.popupActive = true;
        },
        fetchDadosVeiculoParaConfirmacao() {
          const params = new URLSearchParams();
          params.append('outputFormat', 'JSON');
          params.append('idCliente', this.$store.state.AppActiveUser.id);
          params.append('funcionalidade', 'ALTERACAO_DADOS_CONTATO');

          axios.get("/RecuperarVeiculosAtivosCliente", {
                  params, 
                  credentials: 'include',
                  responseEncoding: 'iso88591',
                  withCredentials: true } )
          .then((response) => {
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {            
                this.$router.push({ path: '/login' });
            } else {
                this.listaVeiculos = response.data;   
                this.abrirPopUpOcorrencias();                        
                this.$vs.loading.close();
            }            
          })
          .catch(() => {               
              this.$vs.loading.close();
          }) 
      },
      salvarDadosVeiculos() {        
            this.$vs.loading();  
            const params = new URLSearchParams();                    
            params.append('idCliente', this.$store.state.AppActiveUser.id);
            params.append('itensJSON', JSON.stringify(this.listaVeiculos));      
                 
            axios.post("/rest/DashboardFrota/AtualizarDadosContatoVeiculos", params, {              
                    credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
            .then((response) => {
                if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                    this.$router.push({ path: '/login' });
                } else {               
                    this.$vs.loading.close();     
                    if (response.data.Resultado.hasOwnProperty("error")) {
                        this.poUpConfirmacaoDados.exibirMensagemErro = true;
                        this.poUpConfirmacaoDados.exibirMensagemSucesso = false;
                        this.poUpConfirmacaoDados.mensagem = response.data.Resultado.error;
                    } else {
                        this.poUpConfirmacaoDados.exibirMensagemErro = false;
                        this.poUpConfirmacaoDados.exibirMensagemSucesso = true;
                        this.poUpConfirmacaoDados.mensagem = response.data.Resultado.mensagem;                        
                    }                  
                }
            })
            .catch(() => { 
                this.$vs.loading.close();
            })  
      },
      descartarSalvarDadosVeiculos() {        
            this.$vs.loading();  
            const params = new URLSearchParams();    
            params.append('idCliente', this.$store.state.AppActiveUser.id);                
            params.append('idEmpresa', this.$store.state.AppActiveUser.idEmpresa); 
                 
            axios.post("/rest/DashboardFrota/DescartarAtualizarDadosContatoVeiculos", params, {              
                    credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
            .then((response) => {
                if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                    this.$router.push({ path: '/login' });
                } else {               
                    this.$vs.loading.close();     
                    if (response.data.Resultado.hasOwnProperty("error")) {
                        this.poUpConfirmacaoDados.exibirMensagemErro = true;
                        this.poUpConfirmacaoDados.exibirMensagemSucesso = false;
                        this.poUpConfirmacaoDados.mensagem = response.data.Resultado.error;
                    } else if (response.data.Resultado.hasOwnProperty("error")) {
                        this.poUpConfirmacaoDados.exibirMensagemErro = false;
                        this.poUpConfirmacaoDados.exibirMensagemSucesso = true;
                        this.poUpConfirmacaoDados.mensagem = response.data.Resultado.mensagem;                        
                    } else {
                        if (this.$store.state.AppActiveUser.versaoProduto === 'FAST') {
                            this.$router.push({ path: '/fast' })
                        } else if (this.$store.state.AppActiveUser.versaoProduto === 'BASIC') {
                            this.$router.push({ path: '/mapa' })
                        } else {
                            this.$router.push({ path: '/dashboard/veiculos' })
                        }
                    }
                }
            })
            .catch(() => { 
                this.$vs.loading.close();
            })  
      }
    }
}
</script>